
import {
  defineComponent,
  onActivated,
  onBeforeUnmount,
  onDeactivated,
  onMounted,
  nextTick,
  watch,
} from 'vue'
import resize from '@/components/charts/mixins/resize'
import { init, EChartsOption } from 'echarts'
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'lineChartsCompoents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '350px',
      required: true
    },
    chartData: {
      type: Object,
      default: {}
    },
    chartKey: {
      type: String,
      default: ''
    },
    showChartIdx: {
      type: Number,
      default: 1
    },
  },
  setup(props) {

    const {
      mounted,
      chart,
      beforeDestroy,
      activated,
      deactivated
    } = resize()

    watch(props, (newName, oldName) => {
      initChart()
    });

    const initChart = () => {
      console.log('xAxisList', Object.keys(props.chartData).length)
      if( !Object.keys(props.chartData).length ){
        return false
      }
      const barChart = init(document.getElementById(props.id) as HTMLDivElement)
      const xAxisList = Array.from(props.chartData[props.chartKey].points, ({x})=>x);
      const dataList = Array.from(props.chartData[props.chartKey].points, ({y})=>y);
      const toolKey = {
        rzyeDaily : '融资余额(元)',
        rzjmrDaily : '融资净买入(元)',
        rzyezbDaily : '融资余额占流通市值比(%)',
        rqyeDaily : '融券余额(元)',
        rqjmcDaily : '融券净卖出额(元)',
        rzrqyeDaily : '融资融券余额(股)',
      }
      barChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function (param:any) {
            let list = param.length
            let txt = '<div style="padding-bottom:10px;">' + param[0].name + "</div>"
            for (var i=0;i<list;i++){
              txt += `<div> 
                          <span style='width:12px;height:12px;display:inline-block;border-radius:50%;margin-right:3px;background:${param[i].color}'></span>
                          <span style='width:150px;display:inline-block'>${param[i].seriesName}</span>
                          <span style='width:60px;display:inline-block;text-align:right'>${zh(param[i].data)}</span> 
                      </div>`
            }
            return txt
          }
        },
        grid: {
          top: '30px',
          left: '45px',
          right: '10px',
          bottom: '0',
          containLabel: true
        },
        // color: ['#3B7FEE'],
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: xAxisList,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#999',
              fontSize: 12,
            }
          },
        },
        yAxis: [
          {
            type: 'value',
            // splitLine: {show: false},
            // position: 'left',
            name: '单位（元）',
            // max: maxHoldMarket,
            // min: minHoldMarket,
            // min: 'dataMin',
            min: (value) => {
              let num = 10 ** (value.min.toString().length - 2)
              return Math.floor(value.min / num) * num;
            },
            scale: true, //自适应
            axisPointer: {
              type: 'none',
              label: { show: false }
            },
            axisLabel: {
              show: true,
              align: 'right',
              formatter:function(param: any) {
                // console.log('param', param)
                return `${Math.abs(param) >= 100000000 ? (param / 100000000).toFixed(2) + '亿' : Math.abs(param) >= 10000 ? (param / 10000).toFixed(2) + '万' : param.toFixed(2) }`
                // return param >= 0 ? bigNumberTransform( param ) : `-${bigNumberTransform( Math.abs(param) )}`
                
              }
            }
          },
        ],
        series: [
          {
            name: toolKey[props.chartKey],
            // type: 'line',
            symbol: 'none',
            type: props.showChartIdx === 1 ? 'line' : 'bar',
            // yAxisIndex: 0,
            // barWidth: 3,
            itemStyle: {
              normal: {
                color: '#3B7FEE',
                lineStyle: {
                  width: 1
                },
              }
            },
            data: dataList
          },
        ]
      } as EChartsOption)
      chart.value = barChart
    }

    const zh = (param:any) => {
      return `${Math.abs(param) >= 100000000 ? (param / 100000000).toFixed(2) + '亿' : Math.abs(param) >= 10000 ? (param / 10000).toFixed(2) + '万' : param.toFixed(2) }`
    }

    // const bigNumberTransform = (value:any) => {
    //   const newValue = [0, '', '']
    //   let fr = 1000
    //   let num = 3
    //   let text1 = ''
    //   let fm = 1
    //   while (value / fr >= 1) {
    //     fr *= 10
    //     num += 1
    //     // console.log('数字', value / fr, 'num:', num)
    //   }
    //   if (num <= 4) { // 千
    //     newValue[0] = parseInt(`${value / 1000}`) + ''
    //     newValue[1] = '千'
    //   } else if (num <= 8) { // 万
    //     text1 = parseInt(`${num - 4}`) / 3 > 1 ? '千万' : '万'
    //     // tslint:disable-next-line:no-shadowed-variable
    //     fm = text1 === '万' ? 10000 : 10000000
    //     if (value % fm === 0) {
    //       newValue[0] = parseInt(`${value / fm}`) + ''
    //     } else {
    //       newValue[0] = parseFloat(`${value / fm}`).toFixed(2) + ''
    //     }
    //     newValue[1] = text1
    //   } else if (num <= 16) { // 亿
    //     text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
    //     text1 = (num - 8) / 4 > 1 ? '万亿' : text1
    //     text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
    //     // tslint:disable-next-line:no-shadowed-variable
    //     fm = 1
    //     if (text1 === '亿') {
    //       fm = 100000000
    //     } else if (text1 === '千亿') {
    //       fm = 100000000000
    //     } else if (text1 === '万亿') {
    //       fm = 1000000000000
    //     } else if (text1 === '千万亿') {
    //       fm = 1000000000000000
    //     }
    //     if (value % fm === 0) {
    //       newValue[0] = parseInt(`${value / fm}`) + ''
    //     } else {
    //       newValue[0] = parseFloat(`${value / fm}`).toFixed(2) + ''
    //     }
    //     newValue[1] = text1
    //   }
    //   if (value < 1000) {
    //     newValue[0] = value + ''
    //     newValue[1] = ''
    //   }
    //   return newValue.join('')
    // }

    onMounted(() => {
      mounted()
      nextTick(() => {
        initChart()
      })
    })

    onBeforeUnmount(() => {
      beforeDestroy()
    })

    onActivated(() => {
      activated()
    })

    onDeactivated(() => {
      deactivated()
    })

    return {}
  }
})
